export const KeyCode = {
  Space: 'Space',
  KeyZ: 'KeyZ',
  KeyA: 'KeyA',
}